import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetWorkspaceResourcesRequest,
    GetWorkspaceResourcesResponse
} from "./types";

export { apiName };

const getWorkspaceResources = getCallable<GetWorkspaceResourcesRequest, GetWorkspaceResourcesResponse>(
    apiName,
    "getWorkspaceResources",
    {
        ...endpoints.getWorkspaceResources,
        composer: request => {
            const searchParams = new URLSearchParams();
            if (request.resources) {
                searchParams.append("resources", JSON.stringify(request.resources));
            }

            return {
                url: `/workspaces/${request.workspaceId}/resources?${searchParams.toString()}`,
                options: {
                    method: "GET"
                }
            };
        }
    }
);

export const callables = {
    getWorkspaceResources
};

